import React, { useState } from 'react'
import ResultsListItem from './ResultsListItem'

// Die Rangliste ist eine Tabelle (#178): Beschriftung, Spaltenkoepfe, eine
// Zeile je Treffer. Was nicht sichtbar ist, steht auch nicht im Dokument —
// sonst laese ein Screenreader 20 Zeilen, wo der Sehende 10 sieht.
const SICHTBAR_OHNE_MEHR = 10

const ResultsListReady = ({
    results
}) => {
    const [showMore, setShowMore] = useState(false)
    const sichtbar = showMore ? results : results.slice(0, SICHTBAR_OHNE_MEHR)

    return (
        <div className="jm-results-list">
            {/* Die Klassen des frueheren div-Grids bleiben auf den Tabellenelementen,
                damit das Aussehen pixelgleich bleibt; die Rollen stehen ausdruecklich,
                weil display:grid auf Tabellenelementen deren implizite Rolle im
                Accessibility-Baum verlieren kann. */}
            <table className="jm-results-table" role="table">
                <caption className="jm-sr-only">Deine Treffer, sortiert nach Übereinstimmung</caption>
                <thead role="rowgroup">
                    <tr className="jm-results-list-item grid-container head" role="row">
                        <th scope="col" role="columnheader" className="grid-item-head rank">Rang</th>
                        <th scope="col" role="columnheader" className="grid-item-head percent">Prozent</th>
                        <th scope="col" role="columnheader" className="grid-item-head resultItem">Beruf</th>
                        <th scope="col" role="columnheader" className="grid-item-head participant">Aussteller</th>
                    </tr>
                </thead>
                <tbody role="rowgroup">
                    {sichtbar.map((data, index) => <ResultsListItem
                        key={index}
                        rank={index + 1}
                        data={data}
                    />)}
                </tbody>
            </table>

            {results.length > SICHTBAR_OHNE_MEHR && (
                <button
                    type="button"
                    className="jm-action-button jm-more-button"
                    aria-expanded={showMore}
                    onClick={() => setShowMore(!showMore)}
                >
                    {showMore ? 'Weniger anzeigen' : 'Mehr anzeigen'}
                </button>
            )}
        </div>
    )
}

export default ResultsListReady
